import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Carousel } from "react-responsive-carousel";
import { findProductos } from "../service/producto.service";
import {
  lstMarcas,
  HttpStatus,
  SUCCESS_SERVER,
  Moneda,
  FilterProducto,
  localStoreEnum,
  tipoActualizacionCotizacionDetalle,
} from "../service/ENUM";
import { registrarCotizacion, registrarCotizacionDetalle } from "../service/cotizacion.service";
import { handleSyncDatosCotizacion } from "../service/general";

const LIMIT = 10;

function NewLandingProductTable({ marcaSelect, moneda = Moneda.DOLARES, handleEventUpdateBottomCarrito }) {
  const history = useHistory();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [previewProduct, setPreviewProduct] = useState(null);
  const [cantidad, setCantidad] = useState(1);
  const [mensajeStock, setMensajeStock] = useState("");
  const [resumenOpen, setResumenOpen] = useState(false);
  const [cotizacionResumen, setCotizacionResumen] = useState({
    totalRegistros: 0,
    numSubTotalDol: 0,
    numIgvDol: 0,
    numEnvioDol: 0,
    numTotalDol: 0,
    numSubTotalSol: 0,
    numIgvSol: 0,
    numEnvioSol: 0,
    numTotalSol: 0,
    cantidadDetalleSeleccionado: 0,
  });

  const resolvedMarca = marcaSelect || lstMarcas[0];

  useEffect(() => {
    setPagina(1);
  }, [resolvedMarca?.codigoMarca]);

  useEffect(() => {
    const load = async () => {
      const familias =
        Array.isArray(resolvedMarca?.listFamilia) && resolvedMarca.listFamilia.length > 0
          ? resolvedMarca.listFamilia
          : resolvedMarca?.chrcodigofamilia
          ? [resolvedMarca.chrcodigofamilia]
          : [];

      setLoading(true);
      if (familias.length === 0) {
        setRows([]);
        setTotalRegistros(0);
        setLoading(false);
        return;
      }

      try {
        const rpt = await findProductos({
          chrCodigoFamilia: resolvedMarca?.chrcodigofamilia || null,
          listaFamilia: familias,
          vchDescripcion: null,
          pagina,
          limit: LIMIT,
          filterSubFamilia: "FILTER_SUBFAMILIA_LIST",
          listaSubFamilia: [],              // obligatorio dejarlo vacío
          filterTypeLista: "*",
          filterProducto: "FILTER_ALL"
        });
        if (rpt.status === HttpStatus.HttpStatus_OK) {
          const json = await rpt.json();
          if (json.response.status === SUCCESS_SERVER.SUCCES_SERVER_OK) {
            const mapped = json.listaProductos.map((e) => ({
              chrCodigoProducto: e.chrCodigoProducto,
              vchDescripcion: e.vchDescripcion,
              precioDolar: e.numValorVentaDolarIgv,
              precioSoles: e.numValorVentaSolesIgv,
              numStock: e.numStock,
              familia: e.familia,
              totalRegistros: e.totalRegistros,
            }));
            setRows(mapped);
            setTotalRegistros(mapped[0]?.totalRegistros || 0);
          } else {
            setRows([]);
            setTotalRegistros(0);
          }
        } else {
          setRows([]);
          setTotalRegistros(0);
        }
      } catch (_) {
        setRows([]);
        setTotalRegistros(0);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [resolvedMarca?.codigoMarca, pagina]);

  const openPreview = (product) => {
    if (typeof window !== "undefined" && window.open) {
      window.open(
        `/detalle/${product.familia?.chrCodigoFamilia}/${product.familia?.vchDescripcion}/${product.chrCodigoProducto}`,
        "_parent"
      );
    }
  };

  const formatPrice = (value) => {
    const num = parseFloat(value || 0).toFixed(2);
    if (moneda.numCodigoMoneda === Moneda.DOLARES.numCodigoMoneda) {
      return `$ ${num}`;
    }
    return `S/ ${num}`;
  };

  const totalPaginas = totalRegistros > 0 ? Math.ceil(totalRegistros / LIMIT) : 1;
  const canPrev = pagina > 1;
  const canNext = pagina < totalPaginas;

  const handlePreview = async (product) => {
    setCantidad(1);
    setMensajeStock("");
    setPreviewProduct(product);
    setPreviewImages([]);
    setPreviewOpen(true);
    const rpt = await findProductos({
      chrCodigoFamilia: null,
      vchDescripcion: null,
      listaFamilia: null,
      chrCodigoProducto: product.chrCodigoProducto,
      filterProducto: FilterProducto.FILTER_CODIGO,
      pagina: 1,
      limit: 1,
    });
    if (rpt.status === HttpStatus.HttpStatus_OK) {
      const json = await rpt.json();
      if (json.response.status === SUCCESS_SERVER.SUCCES_SERVER_OK) {
        const imgs = [];
        json.listaProductos.forEach((e) => {
          (e.listaProductoImagen || []).forEach((img) => {
            imgs.push({
              key: img.numCodigoProductoImagen,
              src: `data:image/png;base64,${img.chrSrcImagen}`,
              alt: img.chrNombre,
            });
          });
        });
        setPreviewImages(imgs);
      }
    }
  };

  const handleAddToCart = async () => {
    if (!previewProduct) return;
    if (cantidad > (previewProduct.numStock || 0)) {
      setMensajeStock(`Stock disponible: ${previewProduct.numStock || 0} unidades.`);
      return;
    }
    let cotizacion = handleSyncDatosCotizacion();
    const rpt = await registrarCotizacion(cotizacion);
    if (rpt.status === HttpStatus.HttpStatus_OK) {
      const json = await rpt.json();
      if (json.response.status === SUCCESS_SERVER.SUCCES_SERVER_OK) {
        cotizacion.numCodigoCotizacionOnline = json.numCodigoCotizacionOnline;
        cotizacion.numCodigoCliente = json.numCodigoCliente;
        cotizacion.numCodigoClienteUsuario = json.numCodigoClienteUsuario;
        localStorage.setItem(localStoreEnum.COTIZACION, JSON.stringify(cotizacion));
      }
    }
    const detalleReq = {
      numCodigoCotizacionOnline: cotizacion.numCodigoCotizacionOnline,
      producto: { chrCodigoProducto: previewProduct.chrCodigoProducto },
      numCantidad: cantidad,
      tipoActualizacionCotizacionDetalle: tipoActualizacionCotizacionDetalle.ADICIONAR,
    };
    const rptDetalle = await registrarCotizacionDetalle(detalleReq);
    if (rptDetalle.status === HttpStatus.HttpStatus_OK) {
      const jsonDetalle = await rptDetalle.json();
      if (jsonDetalle.response.status === SUCCESS_SERVER.SUCCES_SERVER_OK) {
        setCotizacionResumen({
          totalRegistros: jsonDetalle.totalRegistros,
          numSubTotalDol: jsonDetalle.numSubTotalDol,
          numIgvDol: jsonDetalle.numIgvDol,
          numEnvioDol: jsonDetalle.numEnvioDol,
          numTotalDol: jsonDetalle.numTotalDol,
          numSubTotalSol: jsonDetalle.numSubTotalSol,
          numIgvSol: jsonDetalle.numIgvSol,
          numEnvioSol: jsonDetalle.numEnvioSol,
          numTotalSol: jsonDetalle.numTotalSol,
          cantidadDetalleSeleccionado: jsonDetalle.cantidadDetalleSeleccionado,
        });
        setPreviewOpen(false);
        setResumenOpen(true);
        if (handleEventUpdateBottomCarrito) handleEventUpdateBottomCarrito(Math.random());
      } else if (jsonDetalle.response.status === SUCCESS_SERVER.SUCCES_SERVER_INFO) {
        setMensajeStock(jsonDetalle.response.error || "");
      }
    }
  };

  const handleGoCart = () => history.push("/carrito");

  return (
    <>
      <section className="nl-section nl-section--plain">
        <div className="nl-container">
          <div className="nl-section__head">
            <h2 className="nl-title nl-title--small">Productos</h2>
            <span className="nl-muted">{resolvedMarca?.decripcion || resolvedMarca?.descripcion}</span>
          </div>
          {loading ? (
            <p>Cargando productos…</p>
          ) : (
            <div className="nl-table-wrap">
              <table className="nl-table">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Nombre</th>
                    <th>Precio (USD)</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item) => (
                    <tr key={item.chrCodigoProducto}>
                      <td>{item.chrCodigoProducto}</td>
                      <td>{item.vchDescripcion}</td>
                      <td>{formatPrice(item.precioDolar)}</td>
                      <td className="nl-table__actions">
                        <Link
                          className="nl-btn nl-btn--ghost"
                          to={`/detalle/${item.familia?.chrCodigoFamilia}/${item.familia?.vchDescripcion}/${item.chrCodigoProducto}`}
                        >
                          Ver detalle
                        </Link>
                        <button className="nl-btn nl-btn--solid" onClick={() => handlePreview(item)}>
                          Vista previa
                        </button>
                      </td>
                    </tr>
                  ))}
                  {rows.length === 0 && (
                    <tr>
                      <td colSpan={4} className="nl-table__empty">
                        No hay productos para esta marca.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="nl-pagination">
                <button className="nl-btn" disabled={!canPrev} onClick={() => setPagina((p) => Math.max(1, p - 1))}>
                  Anterior
                </button>
                <span className="nl-pagination__meta">
                  Página {pagina} de {totalPaginas}
                </span>
                <button className="nl-btn" disabled={!canNext} onClick={() => setPagina((p) => Math.min(totalPaginas, p + 1))}>
                  Siguiente
                </button>
              </div>
            </div>
          )}
        </div>
      </section>

      <Modal
        className="modal-direccion"
        show={previewOpen}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setPreviewOpen(false)}
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="producto-card-modal">
            <div className="producto-card-modal-column1">
              <div className="producto-card-carrousel">
                <Carousel
                  showArrows={false}
                  showStatus={false}
                  showIndicators={false}
                  showThumbs={false}
                  autoPlay={false}
                  infiniteLoop={false}
                  stopOnHover={true}
                  swipeable={true}
                  dynamicHeight={false}
                  emulateTouch={true}
                  autoFocus={true}
                  thumbWidth={75}
                  selectedItem={0}
                >
                  {previewImages.length === 0 ? (
                    <div className="detalle-img">Cargando imágenes…</div>
                  ) : (
                    previewImages.map((img) => (
                      <img key={img.key} className="detalle-img" src={img.src} alt={img.alt} />
                    ))
                  )}
                </Carousel>
              </div>
            </div>
            <div className="producto-card-modal-column2">
              <span className="producto-card-modal-nombre">{previewProduct?.vchDescripcion}</span>
              <span className="producto-card-modal-nombre">{previewProduct?.chrCodigoProducto}</span>
              <span className="producto-card-modal-precio">
                {formatPrice(previewProduct?.precioDolar)}
              </span>
              <span className="producto-card-modal-cantidad">Cantidad</span>
              <div className="producto-card-modal-accion">
                <input
                  type="number"
                  className="form-control"
                  value={cantidad}
                  min={1}
                  onChange={(e) => setCantidad(parseInt(e.target.value, 10) || 1)}
                />
                <button className="btn btn-primary" onClick={handleAddToCart}>
                  <i className="fa fa-shopping-cart"></i>
                  Añadir al Carrito
                </button>
              </div>
              {mensajeStock && <span className="producto-mensaje-stock">{mensajeStock}</span>}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="modal-direccion"
        show={resumenOpen}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setResumenOpen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <i className="fa fa-check fa-producto-detalle"></i> Producto añadido correctamente a su carrito
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-body-modal">
            <div className="producto-det-col1-data">
              {previewImages[0] && <img src={previewImages[0].src} alt={previewProduct?.vchDescripcion} />}
            </div>
            <div className="producto-det-col2-data">
              <div className="producto-det-data-item">
                <span className="label-item-desc nl-summary-desc">{previewProduct?.vchDescripcion}</span>
              </div>
              <div className="producto-det-data-item">
                <label className="label-item">Precio:</label>
                <span className="nl-summary-value">{Moneda.DOLARES.codigoIso4217} {previewProduct ? previewProduct.precioDolar : ""}</span>
              </div>
              <div className="producto-det-data-item">
                <label className="label-item">Cantidad:</label>
                <span className="nl-summary-value">{cotizacionResumen.cantidadDetalleSeleccionado}</span>
              </div>
              <div className="producto-det-data-item">
                <span className="label-item-total nl-summary-cart">
                  Hay {cotizacionResumen.totalRegistros} artículos en su carrito.
                </span>
              </div>
              <div className="producto-det-data-item">
                <label className="label-item">Subtotal:</label>
                <span className="nl-summary-value">{Moneda.DOLARES.codigoIso4217} {cotizacionResumen.numSubTotalDol}</span>
              </div>
              <div className="producto-det-data-item">
                <label className="label-item">Igv:</label>
                <span className="nl-summary-value">{Moneda.DOLARES.codigoIso4217} {cotizacionResumen.numIgvDol}</span>
              </div>
              <div className="producto-det-data-item">
                <label className="label-item">Envío:</label>
                <span className="nl-summary-value">{Moneda.DOLARES.codigoIso4217} 00.00</span>
              </div>
              <div className="producto-det-data-item">
                <label className="label-item">Total:</label>
                <span className="nl-summary-value">{Moneda.DOLARES.codigoIso4217} {cotizacionResumen.numTotalDol}</span>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setResumenOpen(false)}>
            CONTINUAR COMPRANDO
          </button>
          <button className="btn btn-primary" onClick={handleGoCart}>
            <i className="fa fa-check"></i>
            PASAR POR CAJA
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NewLandingProductTable;
